var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.1,
    height: 16.1,
    viewBox: "0 0 16.1 16.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close-circle-outline_2_",
    "data-name": "close-circle-outline (2)",
    d: "M10.05,16.49a6.44,6.44,0,1,1,6.44-6.44,6.449,6.449,0,0,1-6.44,6.44M10.05,2a8.05,8.05,0,1,0,8.05,8.05A8.043,8.043,0,0,0,10.05,2m2.085,4.83L10.05,8.915,7.965,6.83,6.83,7.965,8.915,10.05,6.83,12.135,7.965,13.27l2.085-2.085,2.085,2.085,1.135-1.135L11.185,10.05,13.27,7.965Z",
    transform: "translate(-2 -2)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleOutline);
export default __webpack_public_path__ + "static/media/close_circle_outline.03fdff195a334054b6b656b6b0294f0d.svg";
export { ForwardRef as ReactComponent };